import { UIGameTimedAnimation } from './UIGameTimedAnimation.ts';
import { Point } from '@colonist/game-mechanic-validators';
import { TimeUtils } from '@colonist/utils';
export const SUGGEST_ACTION_ANIMATION_DURATION = 4000;
const ALMOST_INFINITE_ANIMATION_DURATION = TimeUtils.SECONDS_IN_HOUR * TimeUtils.MILLISECONDS * 5;
export class UIGameExpandContractAnimation extends UIGameTimedAnimation {
    updateAnimation(deltaTime, elapsedMS) {
        const { maxSizeChangeRatio, speedMultiplier, originalSize } = this.options;
        const progress = this.totalElapsedMS / 1000;
        const sizeChangePercentage = 1 + Math.sin(progress * speedMultiplier) * maxSizeChangeRatio;
        this.setSize(originalSize * sizeChangePercentage);
    }
    resetToDefaultState() {
        this.setSize(this.options.originalSize);
        this.totalElapsedMS = 0;
    }
    setSize(size) {
        this.viewToAnimate.x = this.options.center.x - size / 2;
        this.viewToAnimate.y = this.options.center.y - size / 2;
        this.viewToAnimate.width = size;
        this.viewToAnimate.height = size;
    }
    static getDefaultOptions(viewToAnimate) {
        return {
            center: new Point(viewToAnimate.x + viewToAnimate.width / 2, viewToAnimate.y + viewToAnimate.height / 2),
            maxSizeChangeRatio: 0.1,
            speedMultiplier: 3.2,
            originalSize: viewToAnimate.width,
            currentSize: viewToAnimate.width,
            frequency: 1
        };
    }
    constructor(viewToAnimate, animationDuration = ALMOST_INFINITE_ANIMATION_DURATION, options){
        super(animationDuration), this.forceEnableAnimation = true;
        this.viewToAnimate = viewToAnimate;
        this.options = options !== null && options !== void 0 ? options : UIGameExpandContractAnimation.getDefaultOptions(viewToAnimate);
    }
}
